<div class="v2-player">
  <div class="scrub-bar-container" aria-label="Playback Position" role="progressbar"
       aria-valuemin="0" [aria-valuemax]="durationSeconds()"
       [aria-valuenow]="positionSeconds()" [aria-valuetext]="positionSpoken()">
    <div class="time-left">
      {{ position() | secondsToMinutes }}
    </div>
    <div class="scrub-bar">
      <div class="progress-container">
        <div
          class="progress-position"
          [ngStyle]="{ width: percPlayed() + '%' }"
        ></div>
      </div>
    </div>
    <div class="time-right">
      {{ durationSeconds() - positionSeconds() | secondsToMinutes }}
    </div>
  </div>

  <div class="player-controls">
    @if (canSkip()) {
      <div class="start-over-control icon-button">
        <button (click)="startOver()" aria-label="Restart current hour" title="Restart Hour">
          <fa-icon [icon]="skipBackIcon"></fa-icon>
        </button>
      </div>
    }

    @if (canScrub() && canScrubBack()) {
      <div class="back-control icon-button">
        <button (click)="reverse()" aria-label="Skip back in the current hour" title="Reverse">
          <fa-icon [icon]="backIcon"></fa-icon>
        </button>
      </div>
    }

    <button (click)="togglePause()" class="playback-toggle" aria-label="Toggle Playback" title="Toggle Playback">
      @switch (controlState()) {
        @case (PlayerControlState.Play) {
          <fa-duotone-icon
            [icon]="playIcon"
            secondaryOpacity="1"
          ></fa-duotone-icon>
        }
        @case (PlayerControlState.Pause) {
          <fa-duotone-icon
            [icon]="pauseIcon"
            secondaryOpacity="1"
          ></fa-duotone-icon>
        }
        @case (PlayerControlState.Indeterminate) {
          <fa-duotone-icon
            [icon]="playIcon"
            secondaryOpacity="1"
          ></fa-duotone-icon>
        }
      }
    </button>

    @if (canScrub()) {
      <div class="forward-control icon-button">
        <button (click)="fastForward()" aria-label="Skip forward in the current hour" title="Fast Forward">
          <fa-icon [icon]="forwardIcon"></fa-icon>
        </button>
      </div>
    }

    @if (canSkip()) {
      <div class="skip-forward-control icon-button">
        <button (click)="skip()" aria-label="Skip to the next hour or show" title="Skip to Next">
          <fa-icon [icon]="skipForwardIcon"></fa-icon>
        </button>
      </div>
    }
  </div>
</div>
